import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "../../../utils/CustomHooks/UseQuery";
import { setLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { featureSwitchName, LOCALSESSIONDATAKEYS, NATIVE_APP_NAMES } from "../../../constants/AppConstants";
import Loader from "../../../components/shared/loader/Loader";
import UseFeatureSwitch from "../../../utils/CustomHooks/UseFeatureSwitch";
import DesktopBenefitOfSuppliesOldVersion from "../Platform/Desktop/DesktopBenefitOfSuppliesOldVersion/DesktopBenefitOfSuppliesOldVersion";
import BMCBenefitOfSuppliesOldVersion from "../Platform/MobileConnect/BMCBenefitOfSuppliesOldVersion/BMCBenefitOfSuppliesOldVersion";
import { BOSPageContext } from "../BenefitOfSuppliesWrapper";
import UseGetPlanDetailsBenefitOfSuppliesPage from "../../../utils/CustomHooks/UseGetPlanDetailsBenefitOfSuppliesPage";
import ServiceUnavailable from "../../Web/Customer/Account/HardwareSignUp/ServiceUnavailable/ServiceUnavailable";
import { getNativeAppName } from "../../../constants/AppMethod";
import BOSCardCarousel from "./BOSCardCarousel/BOSCardCarousel";
import { BROTHER_PLUS_DISPLAY_CONTENT } from "./Bplus/Constants";


export const shenlongPageDisplayInfoContext = React.createContext({});
const BenefitOfSuppliesMain = () => {
    const { isOldVersion, isDesktopAppOld } = useContext(BOSPageContext);
    const queryParams = useQuery();
    const payloadForFeatureSwitch =`${featureSwitchName.PROMOTION_BANNERS},${featureSwitchName.BONUS_PAGES},${featureSwitchName.BROTHERPLUS_BMC},${featureSwitchName.BROTHERPLUS_EASYSETUP},${featureSwitchName.BROTHERPLUS_IPRINTSCAN}`;
    const { featureSwitchValues, featureSwitchAPILoading } = UseFeatureSwitch(payloadForFeatureSwitch);
    const request_from = queryParams.get("request_from");
    const printerModel = queryParams.get("device_model");
    const countryCode = queryParams.get("country");
    const languageCode = queryParams.get("language");
    const [displayContent_BrotherPlus, setDisplayContent_BrotherPlus] = useState(BROTHER_PLUS_DISPLAY_CONTENT.OVERVIEW);
    const {
        trialmonths,
        planCurrency,
        planPrice,
        marketingUrl,
        planResult
    } = UseGetPlanDetailsBenefitOfSuppliesPage({
        'printerModel': printerModel, 
        'countryCode' : countryCode,
        'languageCode': languageCode
    });

    const isBplusEZSetupEnabled = featureSwitchValues?.[featureSwitchName.BROTHERPLUS_EASYSETUP];
    const isBplusIPSEnabled = featureSwitchValues?.[featureSwitchName.BROTHERPLUS_IPRINTSCAN];
    const isBplusBMCEnabled = featureSwitchValues?.[featureSwitchName.BROTHERPLUS_BMC];

    const isBplusFeatureSwitchEnabled = () => {
        let isEnabled = true;
        const appName = getNativeAppName ();
        if(
          (appName === NATIVE_APP_NAMES['EASYSETUP'] && !isBplusEZSetupEnabled) 
          || (appName === NATIVE_APP_NAMES['IPS'] && !isBplusIPSEnabled)
          || (appName === NATIVE_APP_NAMES['MOBILECONNECT'] && !isBplusBMCEnabled)
        ){
          isEnabled = false;
        }
        return isEnabled;
    }
    
    useEffect(()=> {
        setLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROLANGUAGECODE, `${languageCode}-${countryCode}`);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const handleContentToBeDisplayedInBrotherplus = (contentToBeDisplayed) => {
        (contentToBeDisplayed === BROTHER_PLUS_DISPLAY_CONTENT.CONFIRMATION) 
        ? setDisplayContent_BrotherPlus(BROTHER_PLUS_DISPLAY_CONTENT.CONFIRMATION)
        : setDisplayContent_BrotherPlus(BROTHER_PLUS_DISPLAY_CONTENT.OVERVIEW);
    }

    
    const shenlongPageDetails = {
        planResult:planResult, 
        trialmonths:trialmonths, 
        countryCode:countryCode,
        planCurrency:planCurrency,
        planPrice:planPrice,
        marketingUrl: marketingUrl,
        featureSwitchValues: featureSwitchValues,
        featureSwitchAPILoading: featureSwitchAPILoading
    }


    if (planResult.loading || featureSwitchAPILoading) {
        return <Loader></Loader>;
    }

    return(
        <shenlongPageDisplayInfoContext.Provider value={shenlongPageDetails}>
            {
                (request_from && !isOldVersion)
                ? (!isBplusFeatureSwitchEnabled()) 
                    ? <ServiceUnavailable /> 
                    : <BOSCardCarousel 
                        handleBPlusDisplayContent = {handleContentToBeDisplayedInBrotherplus}
                        bPlusDisplayContent = {displayContent_BrotherPlus}
                    />
                : (isDesktopAppOld) 
                ? <DesktopBenefitOfSuppliesOldVersion /> 
                : <BMCBenefitOfSuppliesOldVersion />
            }
       </shenlongPageDisplayInfoContext.Provider>
    )
}

export default BenefitOfSuppliesMain;